import { render, staticRenderFns } from "./warmupConfig.vue?vue&type=template&id=24c4580b&scoped=true"
import script from "./warmupConfig.vue?vue&type=script&lang=js"
export * from "./warmupConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4580b",
  null
  
)

export default component.exports